;(function() {
  'use strict'

  angular.module('core.kitCard', [])
})()
